import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {useAuth } from "../../../../context/LoginContext/AuthContext"
import toast from "react-hot-toast";

export const ParentEditKidUsername = ({ showModal, handleQuestClose, kid,onSuccess }) => {
  const { fetchWithAuth } = useAuth(); // Fetch user details from AuthContext
  const apiUrl = process.env.REACT_APP_API_URL;
  const [username, setUsername] = useState(kid?.username);
  const [usernameValid, setUsernameValid] = useState(true);
  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsername(e.target.value);
    const trimmedValue = value.trim();

        // Check for length >= 5 and no spaces
        if (trimmedValue.length < 5 || /\s/.test(value)) {
          setUsernameValid(false);
        } else {
          setUsernameValid(true);
        }
  };

  const handleSubmit = async () => {
    let valid = true;
    if (!usernameValid) {
      valid = false;
      return;
    }
    if (valid) {
      try {
        const formData = new FormData();

        formData.append("username", username);

        const response = await fetchWithAuth(`${apiUrl}/parent/update-kid/${kid.id}`, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();

        if (!response.ok) {
          if (data?.errors) {
            Object.keys(data.errors).forEach((key) => {
              data.errors[key].forEach((message) => {
                toast.error(message);
              });
            });
          } else {
            toast.error(data?.message || "Failed!");
          }
          return;
        }
        if (response.ok) {
          toast.success("Kid Username updated successfully!");
          onSuccess(username); // pass updated username back

          setTimeout(() => {
            handleQuestClose(); // Close the modal after 5 seconds
          }, 2000);
        } else {
          const error = await response.json();
          toast.error(error.message || "Failed to update kid.");
        }
      } catch (error) {
        toast.error("An error occurred. Please try again.");
      }
    }
  };
  return (
    <>
      <Modal show={showModal} onHide={handleQuestClose} centered>
        <div className="modalHeader">
          <Modal.Header closeButton></Modal.Header>
        </div>
        <Modal.Body>
          <div>
            {/* <p className="DelModalTitl">Edit {kid.name}</p> */}
            <form>
              <div className="mb-3">
                <label htmlFor="username" className="form-label">
                  Enter New Username
                </label>
                <input
                  type={"text"}
                  className={`form-control ${
                    !usernameValid ? "is-invalid" : ""
                  }`}
                  id="username"
                  onChange={handleUsernameChange}
                  value={username}
                  maxLength={15}
                  required
                />
                {!usernameValid && (
                  <div className="invalid-feedback d-block">Username length must be more than 5 character and no
                              space allowed</div>
                )}
              </div>
            </form>
            <Button
              className="btn btn-primary mt-4 w-100"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {" "}
      </>
  );
};
